import React from "react";
import { Col } from "reactstrap";
import classNames from "classnames";

export default function ColDisplay({ children, header }) {
  if (header) {
    return (
      <Col
        xs="2"
        className={classNames("qualitySpecificationEditRow", {
          "text-white": header,
        })}
      >
        <h5>{children}</h5>
      </Col>
    );
  } else {
    return (
      <Col
        xs="2"
        className={classNames("qualitySpecificationEditRow", {
          "text-white": header,
        })}
      >
        {children}
      </Col>
    );
  }
}
